import { render } from "./CardChallengeListItemCompleted.vue?vue&type=template&id=3edc8f4f&scoped=true"
import script from "./CardChallengeListItemCompleted.vue?vue&type=script&lang=js"
export * from "./CardChallengeListItemCompleted.vue?vue&type=script&lang=js"

import "@/css/components/card-challenge-list-item-completed.css?vue&type=style&index=0&id=3edc8f4f&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3edc8f4f"]])

export default __exports__